import { jsx } from "react/jsx-runtime";
import { createElement } from "react";
import { RenderLeafFallback } from "./RenderLeafFallback.js";
import { useRichTextRenderMetadata } from "./RichTextRenderMetadataContext.js";
function LeafRenderer({
  leaf,
  renderLeaf
}) {
  const formatVersion = useRichTextRenderMetadata().formatVersion;
  const fallback = /* @__PURE__ */ jsx(RenderLeafFallback, { leaf });
  return renderLeaf ? createElement(
    renderLeaf,
    {
      formatVersion,
      leaf,
      fallback
    },
    leaf.text
  ) : fallback;
}
export {
  LeafRenderer
};
//# sourceMappingURL=LeafRenderer.js.map
